import React from 'react';
import { Container, Typography, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import Education from './Education';
import Experience from './Experience';
import Skills from './Skills';

const aboutVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1.2 } },
};

const Career = ({ careerBio, skills, experience, education }) => {
  return (
    <Container
      maxWidth="md"
      sx={{ my: 8 }}
      component={motion.div}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={aboutVariants}
    >
      <Typography variant="h4" align="center" gutterBottom>
        Career
      </Typography>
      <Stack spacing={3}>
        <Typography variant="body1" align="center" color="textSecondary">
          {careerBio}
        </Typography>
        <Skills skills={skills} />
        <Experience experience={experience} />
        <Education education={education} />
      </Stack>
    </Container>
  );
};

export default Career;
